<div class="phone-frame" [class.phone-frame--console]="variant === 'console'">
  <!-- Power button -->
  <div class="btn-power"></div>
  <!-- Volume up -->
  <div class="btn-vol-up"></div>
  <!-- Volume down -->
  <div class="btn-vol-down"></div>

  <!-- Screen -->
  <div class="phone-screen">
    <!-- Notch -->
    <div class="notch"></div>
    <!-- Content slot -->
    <div class="screen-content">
      <ng-content></ng-content>
    </div>
  </div>
</div>
